import React, { useEffect, useState } from "react";

// Assets
import "~/assets/sass/pages/invest/evaluteDetail.scss";
// import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import darkNewImg from "~/common/components/Images";
import DetailModal from "../modal/DetailModal";
import { useTranslation } from "react-i18next";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

const FinalCheck = ({
	setCardStep,
	setRequestChkAlert,
	company,
	dataToFinal,
	itemList,
	dataFromReqForm,
	info,
}) => {
	const { t } = useTranslation();
	const [detailEval, setDetailEval] = useState();

	useEffect(() => {
		const setData = itemList?.find((d) => d.idx === dataFromReqForm.settingIdx);
		setDetailEval(setData);
	}, [itemList, dataFromReqForm]);

	const [makeVisible, setMakeVisible] = useState(false);
	const [evaluateCategoryModal, setEvaluateCategoryModal] = useState(false);

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<>
			<section className="c__card evaluate-card request request-card">
				<div className="content">
					<div className="top">
						<h3 className="title">{dataFromReqForm.title}</h3>
						<div className="c__dropdown-wrap">
							<button
								className="btn-dropdown visible"
								onClick={() => setMakeVisible((state) => !state)}
							>
								<ul className="logo-group">
									{dataToFinal?.map((d) => (
										<li key={d.userIdx} className="img-wrap">
											<img
												src={d.img || darkNewImg}
												alt={t(
													"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.imageAlt"
												)}
											/>
											{/*<img src={d.img || lightProfileImg} alt="기업로고" />*/}
										</li>
									))}
								</ul>
							</button>
							<div className={`c__dropdown ${makeVisible ? "visible" : ""}`}>
								<p className="dropdown-title">
									{t(
										"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.title"
									)}{" "}
									<span className="num">{dataToFinal?.length}</span>
								</p>
								<ul className="detail-list">
									{dataToFinal?.map((d) => (
										<li className="c__dropdownItem" key={d.userIdx}>
											<div className="img-wrap">
												<img
													src={
														d.img ||
														(theme === "dark"
															? DarkDefaultProfileImg
															: LightDefaultProfileImg)
													}
													alt={t(
														"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.imageAlt"
													)}
												/>
												{/*<img src={d.img || lightProfileImg} alt="기업로고" />*/}
											</div>
											<dl>
												<dt>
													{company.name ||
														t(
															"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.companyName"
														)}
												</dt>
												<dd>{d.name}</dd>
											</dl>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
					<div className="text">
						<div>{dataFromReqForm.content}</div>
					</div>
					<dl className="vc">
						<dt>{company.name}</dt>
						<dd>{info.name}</dd>
					</dl>
					<button
						type="button"
						className="btn-item"
						onClick={() => setEvaluateCategoryModal(true)}
					>
						{t(
							"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.button01"
						)}
					</button>
				</div>
				<div className="btn-wrap">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setRequestChkAlert(true)}
					>
						{t(
							"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.button02"
						)}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => setCardStep(2)}
					>
						{t(
							"pages.investment.InvestEvalPage.evalRequest.contents.FinalCheck.button03"
						)}
					</button>
				</div>
			</section>
			<DetailModal
				{...{
					evaluateCategoryModal,
					setEvaluateCategoryModal,
					detailEval,
				}}
			/>
		</>
	);
};

export default FinalCheck;
